<template>
  <div class="flex flex-wrap flex-col sm:flex-row justify-center gap-y-3 md:gap-0 sm:justify-between w-full px-4 py-2 items-center">
    <div class="text-xl font-bold text-center">
      Informe Log de Usuario
    </div>
    <div class="flex w-full sm:w-auto flex-wrap gap-3">
      <button @click="downloadReport()" class="px-4 py-2 text-white bg-blue-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
          </svg>
        <span class="ml-3">Descargar informe</span>
      </button>
    </div>
  </div>

  <div class="flex flex-wrap sm:gap-3 flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:justify-between w-full px-4 mb-2 mt-4 items-center">
    <div class="flex flex-wrap bg-gray-100 w-full lg:w-1/4 items-center rounded-lg">
      <svg xmlns="http://www.w3.org/2000/svg" class="inline-block h-4 w-4 mx-2" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      <!-- <input class="inline-block bg-gray-100 outline-none border-transparent focus:border-transparent focus:ring-0 rounded-lg text-sm"
          type="text" @change="(newSearch)=>{queriesToUpdate['search'] = newSearch.target.value;}" :disabled="!queriesToUpdate['criterion']" :placeholder="queriesToUpdate['criterion']?'Buscar...':'Seleccione un filtro...'"/> -->
      <input class="inline-block bg-gray-100 outline-none border-transparent focus:border-transparent focus:ring-0 rounded-lg text-sm"
          type="text" @change="(newSearch)=>{queriesToUpdate['where'] =  (newSearch.target.value != '') ? `respuesta like '${newFiltro.target.value}'` : '' }" placeholder="Seleccione un filtro..."/>
    </div> 
    <div class="flex-row flex-wrap flex gap-5 w-full sm:w-auto items-end">
      <div class="w-full sm:w-auto m-0">
        <select v-model="Tipo_embargo" id="Tipo_embargo"  @change="changeTable()"
                class="w-full mt-3 border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
          <option value="" selected>Filtrar Módulo</option>
          <option value="embargos_personas">Embargos Personas</option>
          <option value="embargos_gobernacion">Embargos Gobernación</option>
          <option value="pasivos">Pasivos Exigibles</option>
          <option value="rendimientos">Rendimientos</option>
        </select> 
      </div>

      <!--SI ES EMBARGO persona FILTRAR Y ORDENAR-->
      <template v-if="Tipo_embargo==='embargos_personas'">
        <div class="w-full sm:w-auto m-0">
          <select @change="(newFiltro)=>{queriesToUpdate['where'] =  (newFiltro.target.value != '') ? `sub_modulo='${newFiltro.target.value}'` : '' }"
                  class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0" >
            <option value="" selected>Filtrar por Submódulo</option>
            <option value="Notificacion">Notificación</option>
            <option value="Levantar Medida">Levantar Medida</option>
            <option value="Egresos">Egresos</option>
            <option value="Soportes">Soportes</option>
          </select>
        </div>
      </template>

       <!--SI ES EMBARGO persona FILTRAR Y ORDENAR-->
      <template v-if="Tipo_embargo==='embargos_gobernacion'">
        <div class="w-full sm:w-auto m-0">
          <select @change="(newFiltro)=>{queriesToUpdate['where'] =  (newFiltro.target.value != '') ? `sub_modulo='${newFiltro.target.value}'` : '' }"
                  class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0" >
            <option value="" selected>Filtrar por</option>
            <option value="Notificacion">Notificación</option>
            <option value="Levantar Medida">Levantar Medida</option>
            <option value="Ingresos">Ingresos</option>
            <option value="Egresos">Egresos</option>
            <option value="Soportes">Soportes</option>
            <option value="Legalización">Legalización</option>
            <option value="Certificaciones">Certificaciones</option>
          </select>
        </div>
      </template>

      <!--SI ES EMBARGO gobernacion FILTRAR Y ORDENAR-->
      <template v-else-if="Tipo_embargo==='pasivos'">
        <div class="w-full sm:w-auto m-0">
          <select @change="(newFiltro)=>{queriesToUpdate['where'] =  (newFiltro.target.value != '') ? `sub_modulo='${newFiltro.target.value}'` : '' }" class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
            <option value="" selected>Filtrar por</option>
            <option value="CAP">CAP</option>
            <option value="Cargue SIAFF">Cargue SIAFF</option>
            <option value="Cargue Fenecidas">Cargue Fenecidas</option>
          </select>
        </div>
      </template>

      <!--SI ES EMBARGO gobernacion FILTRAR Y ORDENAR-->
      <template v-else-if="Tipo_embargo==='rendimientos'">
        <div class="w-full sm:w-auto m-0">
          <select @change="(newFiltro)=>{queriesToUpdate['where'] =  (newFiltro.target.value != '') ? `sub_modulo='${newFiltro.target.value}'` : '' }" class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
            <option value="" selected>Filtrar por</option>
            <option value="Tasas E.A">Tasas E.A</option>
            <option value="Extractos Bancarios">Extractos Bancarios</option>
          </select>
        </div>
      </template>

      <!-- ORDEN ASC/DESC-->
      <button @click="orderAscDesc()" 
        class="mt-3 sm:m-auto border border-gray-300 rounded-md text-gray-600 px-3 py-[9px] bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0" style=" margin-top: 30px;">
        <span>Ordenar {{ queriesToUpdate['order']?queriesToUpdate['order']:'ASC' }}.</span>
      </button>

      <button @click="executeQueries()"
              class="mt-3 font-bold sm:m-auto border border-gray-300 hover:border-gray-400 px-3 py-[9px] text-white bg-green-500 hover:bg-green-600 rounded-md focus:outline-none text-xs focus:ring-0 flex flex-row items-center space-x-2" style=" margin-top: 30px;">
        <span>BUSCAR</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
        </svg>
      </button>
    </div>
  </div>

  <div class="mt-6 overflow-x-auto">
      <table class="w-full table-auto">
        <thead class="">
          <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
            <th class="px-4 py-3">Fecha</th>
            <th class="px-4 py-3">Usuario</th>
            <th class="px-4 py-3">Módulo</th>
            <th class="px-4 py-3">Sub Módulo</th>
            <th class="px-4 py-3">Acción</th>
            <th class="px-4 py-3">Respuesta</th>
          </tr>
        </thead>
        <tbody class="text-sm font-normal text-gray-700 text-center">
          <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(data, index) in collectionData" :key="index">
            <td class="px-4 py-4">
              {{ dateTime(data.created_at) }}
            </td>
            <td class="px-4 py-4">
              {{ data.usuario.usuario }} - {{ data.usuario.nombre_completo }}
            </td>
            <td class="px-4 py-4">
              {{ data.modulo }}
            </td>
            <td class="px-4 py-4">
              {{ data.sub_modulo }}
            </td>
            <td class="px-4 py-4">
              {{ data.accion }}
            </td>
            <td class="px-4 py-4">
              {{ data.respuesta }}
            </td>
          </tr>
        </tbody>
      </table>
  </div>

  <!--PAGINACIÓN-->
  <div class="flex flex-col items-center w-full px-4 py-4 text-sm text-gray-500 justify-center mx-auto">
    <div class="flex items-center justify-between space-x-2">
      <button type="button" class="hover:text-gray-600" v-if="paginate.hasPreviousPage"
              @click="listCollectionData(urlApi, setupUpdateValues, authToken, paginate.page-1, queries['orderBy'], queries['order'], queries['criterion'], queries['search'], queries['where'], queries['isPaginate'], { 'take' : 6});">
        Anterior
      </button>
      <div class="flex flex-row space-x-1">
        <button type="button"
                :class="'flex px-2 py-px '+(paginate.page===page?'text-white bg-blue-400 border border-blue-400':'border border-blue-400 hover:bg-blue-400 hover:text-white')"
                v-for="(page, index) in paginate.pageCount" :key="index"
                @click="this.listCollectionData(urlApi, setupUpdateValues, authToken, page, queries['orderBy'], queries['order'], queries['criterion'], queries['search'], queries['where'], queries['isPaginate'], { 'take' : 6});">
          {{ page }}
        </button>
      </div>
      <button type="button" class="hover:text-gray-600" v-if="paginate.hasNextPage"
              @click="listCollectionData(urlApi, setupUpdateValues, authToken,  paginate.page+1, queries['orderBy'], queries['order'], queries['criterion'], queries['search'], queries['where'], queries['isPaginate'], { 'take' : 6});">
        Siguiente
      </button>
    </div>
  </div>
</template>
<script>
import {utils, writeFile} from "xlsx-js-style";
import {useAuth} from "@/components/auth/store/composables";
import {copiaProfunda} from "@/common/constants";
import {useLayoutMain, listCollectionData} from "@/layouts/main";
import {ref, reactive, computed} from 'vue';
import moment from 'moment';

export default {
  name: 'InformeLog',
  data: function () {
    return {
      Object: Object,
      console: console,
      dataFile : []
    }
  },
  async setup() {
    const dateRangePicker = ref(undefined);
    const authStored = useAuth();
    const dataUser = ref(localStorage.getItem('user'));
    const idUser = JSON.parse(dataUser.value);
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const queriesToUpdate = ref({});
    const valueRangeToUpdate = ref({});
    const collectionInforme = ref([]);
    const Tipo_embargo = ref('');
    const listCollectionDataRef = ref(listCollectionData);

    const listApi = reactive({
      list: process.env.VUE_APP_NEST_LOGGER_FINDALL
    });

    const changeTable = async () => {
      try {
        queriesToUpdate.value.criterion = 'modulo';
        queriesToUpdate.value.search = Tipo_embargo.value;

        queries.value.criterion = 'modulo';
        queries.value.search = Tipo_embargo.value;

        const apiUrl = process.env.VUE_APP_NEST_LOGGER_FINDALL;

        const res = await listCollectionData(
          apiUrl,
          { 'collectionData': collectionData.value },
          authToken.value,
          undefined,
          undefined,
          undefined,
          'modulo',
          Tipo_embargo.value,
          undefined,
          true,
          { 'take' : 6 }
        );

        // Actualizar la referencia reactiva collectionData
        collectionData.value = res.data;
        paginate.value = res.meta;

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const urlApi = computed(() => {
        return process.env.VUE_APP_NEST_LOGGER_FINDALL
    });
    
    const {                       
      paginate,       
      queries,        
      setupUpdateValues
  } = await useLayoutMain(view, collectionData, authToken, undefined, undefined, listApi, { 'take' : 6});
    
    return  {
              paginate, 
              queries, 
              collectionInforme, 
              setupUpdateValues, 
              authToken, 
              collectionData, 
              dateRangePicker, 
              listApi, 
              queriesToUpdate, 
              dataUser, 
              idUser,
              valueRangeToUpdate, 
              Tipo_embargo,
              changeTable,
              listCollectionData: listCollectionDataRef,
              urlApi
            }
  },
  methods: {
    dateTime(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm');
    },
    executeQueries() {
      console.log('this.queriesToUpdate',this.queriesToUpdate);

      this.updateQueries('page', '');

      this.listApi.list = process.env.VUE_APP_NEST_LOGGER_FINDALL;

      this.queries = copiaProfunda(this.queriesToUpdate);

      console.log('this.queries',this.queries);
    },
    orderAscDesc() {
      this.queriesToUpdate['order'] = this.queriesToUpdate['order'] === 'DESC' ? 'ASC' : 'DESC';
    },
    updateQueries(key, value) {
      this.queriesToUpdate[key] = value;
    },
    useDateRangePicker() {
      let [dateStart, dateEnd] = this.dateRangePicker.getDates();
      dateStart = dateStart.toISOString().split('T')[0];
      dateEnd = dateEnd.toISOString().split('T')[0];
      this.queriesToUpdate['search'] = '';
      if(this.queriesToUpdate.criterion == 'fecha_oficio'){
        this.updateQueries('where', `table.fecha_oficio>='${dateStart}' and table.fecha_oficio<='${dateEnd}'`);
      }else if(this.queriesToUpdate.criterion == 'fecha_recibido_oficio' ){
        this.updateQueries('where', `fecha_recibido_oficio>='${dateStart}' and fecha_recibido_oficio<='${dateEnd}'`);
      }else if(this.queriesToUpdate.criterion == 'fecha_egreso' ){
        this.updateQueries('where', `fecha_egreso>='${dateStart}' and fecha_egreso<='${dateEnd}'`);
      }
    },
    async downloadReport() {
      await this.listCollectionData(
        (this.Tipo_embargo == 'persona' ) ? process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL : process.env.VUE_APP_NEST_EMBARGOGOBERNACION_FINDALL, {'collectionInforme': this.collectionInforme}, this.authToken,  this.page, this.queries['orderBy'], this.queries['order'], 
      this.queries['criterion'], this.queries['search'], this.queries['where'], true, { 'take' : 20000})
      .then(res => {

        if(this.Tipo_embargo == 'persona'){
            const report = [['Número Proceso', 'Tipo Proceso',  'Entidad Notificadora', 'Número Oficio', 'Fecha Oficio', 'Fecha Recibido OFicio', 'Identificación Demandante', 'Demandante', 'Tipo Persona Demandado', 'Identificación Demandado','Demandado', 'Limite Embargo', 'Saldo Actual']];
            
            this.dataFile = res.data;
          
            for (const data of this.dataFile) {
              const dataReport = {};
              for (const key in data) {
                if(['numero_proceso', 'entidad_notifica_embargo',  'numero_oficio', 'fecha_oficio', 'fecha_recibido_oficio', 'valor_inicial', 'valor_actual'].includes(key)) {
                  dataReport[key] = data[key];
                }
                else if(key === 'tipoProceso') {
                  dataReport['tipoProceso'] = data[key]['nombre'];
                }
                else if(key === 'demandante') {
                  dataReport['demandante'] = data[key]['nombre'];
                  dataReport['identificacion_demandante'] = data[key]['identificacion'];
                }
                else if(key === 'demandado') {
                  dataReport['demandado'] = data[key]['nombre'];
                  dataReport['identificacion_demandado'] = data[key]['identificacion'];
                  dataReport['tipo_persona_demandado'] = data[key]['tipoPersona']['nombre'];
                }

              }  
              const {
                numero_proceso,
                tipoProceso,
                entidad_notifica_embargo,
                numero_oficio,
                fecha_oficio,
                fecha_recibido_oficio,
                identificacion_demandante,
                demandante,
                tipo_persona_demandado,
                identificacion_demandado,
                demandado,
                valor_inicial,
                valor_actual,
              } = dataReport

              report.push([
              numero_proceso,
              tipoProceso,
              entidad_notifica_embargo,
              numero_oficio,
              fecha_oficio,
              fecha_recibido_oficio,
              identificacion_demandante,
              demandante,
              tipo_persona_demandado,
              identificacion_demandado,
              demandado,
              Number(valor_inicial),
              Number(valor_actual),
            ]);
            }
        
            const workBook = utils.book_new();
            const workSheet = utils.aoa_to_sheet(report);
            utils.book_append_sheet(workBook, workSheet, 'Informe');  


            // Definir el ancho deseado para cada columna
            const columnWidths = [
              { wch: 18 }, // Ancho de la primera columna
              { wch: 18 }, // Ancho de la segunda columna
              { wch: 25 }, // Ancho de la segunda columna
              { wch: 18 },
              { wch: 18 },
              { wch: 22 },
              { wch: 24 },
              { wch: 24 },
              { wch: 24 },
              { wch: 24 },
              { wch: 23 },
              { wch: 20 },
              { wch: 20 },

            ];

            
            // Aplicar los anchos de columna a la hoja de trabajo
            workSheet['!cols'] = columnWidths;


            /** 
             * Genera un objeto de bordes para una celda.
             * @param {string} width - El ancho del borde. Puede ser "thin" o "medium".
             * @param {string} color - El color del borde en formato hexadecimal.
             * @returns {Object} - El objeto de bordes.
            */
            const generateBorder = (width, color) => {
              const borderObject = {};
              for (const side of ['left', 'right', 'bottom', 'top']) {
                borderObject[side] = {
                  style: width,
                  color: {
                    rgb: color
                  }
                };
              }
              return borderObject;
            };

            /**
            Agrega formato a las celdas del informe y genera el archivo xlsx.
            */
            for (const cell in workSheet) {
              if (cell.charAt(cell.length))
                workSheet[cell]['s'] = {
                  font: {
                    bold: true,
                    color: {
                      rgb: 'FFFFFF'
                    },
                    sz: '10',
                    name: 'Open Sans'
                  },
                  border: generateBorder('medium', '000000'),
                  fill: {
                    bgColor: {
                      rgb: '000000'
                    }
                  }
                };
              else if (typeof workSheet[cell] === 'object') workSheet[cell]['s'] = {
                font: {
                  sz: '12',
                  name: 'Times New Roman'
                },
                border: generateBorder('thin', '000000')
              };
            }  
            writeFile(workBook, `informe_embargos_personas.xlsx`); 

        }else{

          const report = [['Número Egreso', 'Fecha Egreso', 'Identificación Demandante', 'Demandante', 'Concepto', 'Número Proceso','Banco', 'Cuenta Bancaria', 'Tipo Cuenta', 'Limite Embargo' , 'Saldo Actual']];

          this.dataFile = res.data;

          for (const data of this.dataFile) {
              const dataReport = {};
              for (const key in data) {
                if(['numero_egreso', 'fecha_egreso',  'concepto', 'numero_proceso', 'valor', 'valor_actual'].includes(key)) {
                  dataReport[key] = data[key];
                }
                else if(key === 'demandante') {
                  dataReport['demandante'] = data[key]['nombre'];
                  dataReport['identificacion_demandante'] = data[key]['identificacion'];
                }
                else if(key === 'cuentaBancaria') {
                  dataReport['nombre_banco'] = data[key]['banco']['nombre_banco'];
                  dataReport['cuentaBancaria'] = data[key]['cuenta_bancaria'];
                  dataReport['tipo_cuenta'] = data[key]['tipo_cuenta'];
                }

              }  
              const {
                numero_egreso,
                fecha_egreso,
                identificacion_demandante,
                demandante,
                concepto,
                numero_proceso,
                nombre_banco,
                cuentaBancaria,
                tipo_cuenta,
                valor,
                valor_actual,
              } = dataReport

              report.push([
              numero_egreso,
              fecha_egreso,
              identificacion_demandante,
              demandante,
              concepto,
              numero_proceso,
              nombre_banco,
              cuentaBancaria,
              tipo_cuenta,
              Number(valor),
              Number(valor_actual),
            ]);
            }
        
            const workBook = utils.book_new();
            const workSheet = utils.aoa_to_sheet(report);
            utils.book_append_sheet(workBook, workSheet, 'Informe');  


            // Definir el ancho deseado para cada columna
            const columnWidths = [
              { wch: 18 }, // Ancho de la primera columna
              { wch: 18 }, // Ancho de la segunda columna
              { wch: 25 }, // Ancho de la segunda columna
              { wch: 18 },
              { wch: 25 },
              { wch: 22 },
              { wch: 24 },
              { wch: 24 },
              { wch: 24 },
              { wch: 24 },
              { wch: 23 }
            ];

            
            // Aplicar los anchos de columna a la hoja de trabajo
            workSheet['!cols'] = columnWidths;


            /** 
             * Genera un objeto de bordes para una celda.
             * @param {string} width - El ancho del borde. Puede ser "thin" o "medium".
             * @param {string} color - El color del borde en formato hexadecimal.
             * @returns {Object} - El objeto de bordes.
            */
            const generateBorder = (width, color) => {
              const borderObject = {};
              for (const side of ['left', 'right', 'bottom', 'top']) {
                borderObject[side] = {
                  style: width,
                  color: {
                    rgb: color
                  }
                };
              }
              return borderObject;
            };

            /**
            Agrega formato a las celdas del informe y genera el archivo xlsx.
            */
            for (const cell in workSheet) {
              if (cell.charAt(cell.length))
                workSheet[cell]['s'] = {
                  font: {
                    bold: true,
                    color: {
                      rgb: 'FFFFFF'
                    },
                    sz: '10',
                    name: 'Open Sans'
                  },
                  border: generateBorder('medium', '000000'),
                  fill: {
                    bgColor: {
                      rgb: '000000'
                    }
                  }
                };
              else if (typeof workSheet[cell] === 'object') workSheet[cell]['s'] = {
                font: {
                  sz: '12',
                  name: 'Times New Roman'
                },
                border: generateBorder('thin', '000000')
              };
            }  

            writeFile(workBook, `informe_embargos_gobernacion.xlsx`); 

        }
           
      });
    },
  }
}

</script>


